import Preact from 'preact'
import { connect } from 'preact-redux'
import { fetchSchedule } from '../../actions/data'
import { MatchNav } from '../../../shared/components/MatchNav'
import { MAX_AGE } from '../../config'

import { isStale } from '../../../lib/is-acceptable-age'

import {
  IAppState,
  IStateMatches,
  IScheduleMatch,
  ScheduleMatches,
  IScheduleMatches
} from '../../../types'

const { h, Component } = Preact

interface IDispatchProps {
  fetchSchedule: () => void
}

interface IStateProps {
  schedule: IScheduleMatches
  BASE_URL: string
  currentUrl: string
}

type Props = IStateProps & IDispatchProps

interface IState {
  currentId: string | false | undefined
}

class MatchNavContainerComponent extends Component<Props, IState> {
  constructor(props) {
    super(props)
    this.state = {
      currentId: idFromUrl(props.currentUrl)
    }
  }

  public componentDidMount() {
    if (isStale(this.props.schedule.lastUpdated, MAX_AGE.schedule)) {
      this.props.fetchSchedule()
    }
  }

  public componentWillReceiveProps(nextProps: Props) {
    if (nextProps.currentUrl !== this.props.currentUrl) {
      const currentId = idFromUrl(nextProps.currentUrl)
      this.setState({
        currentId
      })
    }
  }

  public render() {
    const { BASE_URL, schedule } = this.props
    const { currentId } = this.state

    return (
      <MatchNav
        BASE_URL={BASE_URL}
        currentId={currentId}
        matches={schedule.data}
      />
    )
  }
}

const mapStateToProps = ({ data, general }: IAppState): IStateProps => {
  const { schedule } = data
  const { urls } = general
  return {
    schedule,
    BASE_URL: urls.BASE_URL,
    currentUrl: urls.currentUrl
  }
}

const mapDispatchToProps = (dispatch): IDispatchProps => ({
  fetchSchedule: () => dispatch(fetchSchedule())
})

const MatchNavContainer = connect(mapStateToProps, mapDispatchToProps)(
  // @ts-ignore
  MatchNavContainerComponent
)

const idFromUrl = (url: string): string | false => {
  try {
    return url.match(/\?id=([^&]*)/)[1] || false
  } catch (err) {
    return false
  }
}

export { MatchNavContainer }
